export default {
  baseStyle: {
    text: {
      color: 'grey.980'
    }
  }
};